import { capitalize } from '@sonar-software/sonar-ts-lib';
import { ClassificationLevel } from '@sonar-software/sonar-core';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { Tag } from 'antd';

const classificationColors: Record<ClassificationLevel, string> = {
	[ ClassificationLevel.None ]: '',
	[ ClassificationLevel.Low ]: 'purple',
	[ ClassificationLevel.Medium ]: 'gold',
	[ ClassificationLevel.High ]: 'orange',
	[ ClassificationLevel.Critical ]: 'red'
};

export interface AuditTrailClassifcationTagProps {
	classification?: ClassificationLevel;
}

export const ClassificationTag: React.FC<AuditTrailClassifcationTagProps> = ({ classification }) => {
	if (classification === 'null') {
		return COPY_SPECIFIC.NONE;
	}

	return (
		<Tag color={ classificationColors[ classification as ClassificationLevel ] }>
			{ capitalize(classification) }
		</Tag>
	);
};
